<template>
  <div class="row mt-5 m-0">
    <section class="col-lg m-0 px-0 row pb-5 mb-5">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <div class="m-0 row tabSteps text-center">
          <div
            class="col border-bottom border-primary steps py-2"
            :class="{ 'active btn-primary': card.dadosPessoais }"
          >
            <span>Dados Pessoais</span>
          </div>
          <div
            class="col border-bottom border-primary steps py-2"
            :class="{ 'active btn-primary': card.pedido }"
          >
            <span>Confirmar Pedido</span>
          </div>
          <div
            class="col border-bottom border-primary steps py-2"
            :class="{ 'active btn-primary': card.pagamento }"
          >
            <span>Pagamento</span>
          </div>
        </div>
        <CardDadosPessoais
          v-if="card.dadosPessoais"
          @goToStep="goToStep"
        ></CardDadosPessoais>
        <CardConfirmarPedido
          v-if="card.pedido"
          @goToStep="goToStep"
        ></CardConfirmarPedido>
        <CardPagamento
          v-if="card.pagamento"
          @goToStep="goToStep"
        ></CardPagamento>
        <CardSucesso v-if="card.sucesso" @goToStep="goToStep"></CardSucesso>
      </div>
    </section>
  </div>
</template>
<script>
import CardDadosPessoais from "@/components/Card-dadosPessoais.vue";
import CardConfirmarPedido from "@/components/Card-confirmarPedido.vue";
import CardPagamento from "@/components/Card-pagamento.vue";
import CardSucesso from "@/components/Card-sucesso.vue";

export default {
  name: "checkout",
  components: {
    CardDadosPessoais,
    CardConfirmarPedido,
    CardPagamento,
    CardSucesso
  },
  data() {
    return {
      card: {
        dadosPessoais: true,
        pedido: false,
        pagamento: false,
        sucesso: false
      }
    };
  },
  created() {
    const el = document.body;
    el.classList.remove("overflow-hidden");
  },
  methods: {
    goToStep(page) {
      switch (page) {
        case "pedido":
          this.card.dadosPessoais = false;
          this.card.pedido = true;
          this.card.pagamento = false;
          this.card.sucesso = false;
          break;
        case "pagamento":
          this.card.dadosPessoais = false;
          this.card.pedido = false;
          this.card.pagamento = true;
          this.card.sucesso = false;
          break;
        case "sucesso":
          this.card.dadosPessoais = false;
          this.card.pedido = false;
          this.card.pagamento = false;
          this.card.sucesso = true;
          break;
        case "dados":
        default:
          this.card.dadosPessoais = true;
          this.card.pedido = false;
          this.card.pagamento = false;
          this.card.sucesso = false;
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tabSteps {
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  .steps {
    background: #f9f9f9;
    color: inherit;
    padding: 3px 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    transition: background 0.4s, padding-left 0.2s;
  }
}
</style>
